import * as React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { Divider } from '@mui/material';
var SectionHeader = function (_a) {
    var title = _a.title, secondaryTitle = _a.secondaryTitle, hideDivider = _a.hideDivider, headerClassName = _a.headerClassName;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-items-center lfc-gap-3 ".concat(headerClassName) },
            typeof title === 'string' ? (React.createElement(React.Fragment, null,
                React.createElement(GBTypography, { variant: "h2", className: "lfc-hidden lg:lfc-block" }, title),
                React.createElement(GBTypography, { variant: "sh1", className: "lg:lfc-hidden" }, title))) : (title),
            secondaryTitle || null),
        !hideDivider ? React.createElement(Divider, { className: "lfc-my-4 lfc-text-grey-200" }) : null));
};
export default SectionHeader;
//# sourceMappingURL=SectionHeader.js.map